import React from 'react';
// import { Component } from 'react';
import './styles/Projects.css';

function Projects(){
    return(
        <div>
            Projects
        </div>
    )
}


export default Projects;